import dc from '../lib/directchat_lib';
import cookie from '../lib/treffcook';

export default class DirectChat {
  constructor(el) {
    this.el = el;
    // const dcsound2 = document.getElementById('dcaudio');
    cookie.Set('dc', parseInt($('body').attr('data-dc-en'), 10));
    this.lastid = 0;
    this.dcSoundPlayer = document.getElementById('dcaudio');
    if (parseInt(cookie.Get('dccrrvw'), 10) === 1) {
      this.showList();
    }
    if (parseInt(cookie.Get('dccrrvw'), 10) === 2) {
      this.showConversation();
    }
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    // Toggle the sound by dc
    $('body').on('click', '#dc-sound-toggle-234', () => {
      // cookie.Set('private_sound', newVal, 3600, '/');
      $.ajax({
        url: '/directchat/ajax_chat.php',
        method: 'POST',
        type: 'json',
        data: {
          mode: 'toggle1to1_sound'
        },
        success: () => {}
      });
      if (parseInt(cookie.Get('private_sound'), 10) === 1) {
        $('#dc-sound-toggle i').removeClass('fa-volume-off');
        $('#dc-sound-toggle i').addClass('fa-volume-up');
      } else {
        $('#dc-sound-toggle i').removeClass('fa-volume-up');
        $('#dc-sound-toggle i').addClass('fa-volume-off');
      }
    });
    // Minimize/maximize or close the chatbox.
    $('body').on('click', '#chatbox-close-button', () => {
      cookie.Set('dcbxmin', 0, 3600, '/');
      cookie.Set('dclsopn', 0, 3600, '/');
      cookie.Set('dccrrvw', 0, 3600, '/');
      cookie.Set('dccrrto', 0, 3600, '/');
      cookie.Set('dccrr', 0, 3600, '/');
      cookie.Set('dccrrname', '', 3600, '/');
      this.stopNewLinesWatchDog();
      $(this.el).hide();
    });

    $('body').on('click', '#chatbox-toggle-button', () => {
      dc.updateSliderToggle($('#chatbox-toggle-button'));
    });

    // Binds clicks.
    // Load a chat-conversation from the chat-conversations list.
    $('body').on('click', '#conversations-list > a', elm => {
      elm.preventDefault();
      let rm = false;
      let ammount = 0;
      let isLast = false;
      let id = '';
      let to = '';
      let name = '';
      if (elm.target && elm.target.parentElement.nodeName === 'A') {
        id = elm.target.parentElement.getAttribute('data-cid');
        to = elm.target.parentElement.getAttribute('data-to');
        name = elm.target.parentElement.getAttribute('data-name');
      } else if (elm.target && elm.target.parentElement.nodeName === 'SPAN') {
        id = elm.target.parentElement.parentElement.getAttribute('data-cid');
        to = elm.target.parentElement.parentElement.getAttribute('data-to');
        name = elm.target.parentElement.parentElement.getAttribute('data-name');
        if (elm.target.parentElement.classList.contains('dcl-delete')) {
          rm = id;
          ammount = elm.target.parentElement.parentElement.parentElement.querySelectorAll(
            'a'
          ).length;
          if (parseInt(ammount, 10) === 1) {
            isLast = true;
          }
        }
      } else if (elm.target && elm.target.parentElement.nodeName === 'I') {
        id = elm.target.parentElement.parentElement.parentElement.getAttribute(
          'data-cid'
        );
        to = elm.target.parentElement.parentElement.parentElement.getAttribute(
          'data-to'
        );
        name = elm.target.parentElement.parentElement.parentElement.getAttribute(
          'data-name'
        );
        if (
          elm.target.parentElement.parentElement.classList.contains(
            'dcl-delete'
          )
        ) {
          rm = id;
          ammount = elm.target.parentElement.parentElement.parentElement.parentElement.querySelectorAll(
            'a'
          ).length;
          if (parseInt(ammount, 10) === 1) {
            isLast = true;
          }
        }
      } else {
        id = elm.target.getAttribute('data-cid');
        to = elm.target.getAttribute('data-to');
        name = elm.target.getAttribute('data-name');
      }
      if (rm) {
        this.removeListItem(id, isLast);
      } else {
        cookie.Set('dclsopn', 0, 3600, '/');
        cookie.Set('dccrr', id, 3600, '/');
        cookie.Set('dccrrvw', 2, 3600, '/');
        cookie.Set('dccrrname', name, 3600, '/');
        cookie.Set('dccrrto', to, 3600, '/');
        this.openConversation(id, to, name);
      }
    });

    // Binds clicks of the send message button
    $('body').on('click', '#send-chat-message', () => {
      // const reciver = $('body')
      // .find('#chat-message-field')
      // .parents('.dchat');
      this.sendChatMessage();
      // this.loadConversation(reciver.attr('id'));
    });

    // Binds clicks.
    // Executes necessary actions to the invitation process.
    $('body').on('click', '#directchat-invite-btn', elm => {
      elm.preventDefault();
      const id = elm.target.getAttribute('data-uid');
      const name = elm.target.getAttribute('data-uname');
      $.ajax({
        url: '/directchat/ajax_chat.php',
        method: 'POST',
        type: 'html',
        data: {
          mode: 'invite',
          uid: id,
          uname: name
        },
        success: data => {
          if (data) {
            const response = $.parseJSON(data);
            cookie.Set('dccrr', response.dcid, 3600, '/');
            cookie.Set('dccrrvw', 2, 3600, '/');
            // $('#directchat-content').html(response.render);
            // // dc.checkChatState();
            // $(this.el).show();
            // $('#chatbox-toggle-button').click();
            // $(elm.target).hide();
            this.openConversation(id, id, name, 1);
          }
        }
      });
    });

    // Binds clicks.
    // Load the chat-conversations list.
    $('body').on(
      'click',
      '#directchat-menu-link, #directchat-list-button',
      () => {
        this.stopNewLinesWatchDog();
        cookie.Set('dccrr', 0, 3600, '/');
        cookie.Set('dculatm', 0, 3600, '/');
        cookie.Set('dccrrvw', 1, 3600, '/');
        cookie.Set('dclsopn', 1, 3600, '/');
        $.ajax({
          url: '/directchat/ajax_chat.php',
          method: 'POST',
          type: 'html',
          data: {
            mode: 'list'
          },
          success: data => {
            if (data) {
              const response = $.parseJSON(data);
              $('#directchat-content').html(response.render);
              $(this.el).show();
              $('#chatbox-toggle-button').click();
            }
          }
        });
      }
    );
  }

  showConversation() {
    const id = cookie.Get('dccrr');
    const to = cookie.Get('dccrrto');
    const name = cookie.Get('dccrrname');
    this.openConversation(id, to, name);
  }

  showList() {
    this.stopNewLinesWatchDog();
    cookie.Set('dccrr', 0, 3600, '/');
    cookie.Set('dculatm', 0, 3600, '/');
    cookie.Set('dccrrvw', 1, 3600, '/');
    cookie.Set('dclsopn', 1, 3600, '/');
    $.ajax({
      url: '/directchat/ajax_chat.php',
      method: 'POST',
      type: 'html',
      data: {
        mode: 'list'
      },
      success: data => {
        if (data) {
          const response = $.parseJSON(data);
          $('#directchat-content').html(response.render);
          $(this.el).show();
          // $('#chatbox-toggle-button').click();
          if (parseInt(cookie.Get('dcbxmin'), 10) === 0) {
            $('#chatbox-toggle-button').click();
          }
        }
      }
    });
  }

  removeListItem(id, isLast) {
    $.post(
      '/directchat/ajax_chat.php',
      {
        dcid: id,
        mode: 'listRM',
        last: isLast
      },
      () => {
        $(`a[data-cid="${id}"]`).remove();
        if (isLast) {
          this.showList();
        }
      }
    );
  }

  // Send a message.
  sendChatMessage() {
    const message = $('#chat-message-field');
    const reciver = $('#chat-message-field').parents('.dchat');
    const to = parseInt(reciver.attr('data-reciver'), 10);
    const from = parseInt(reciver.attr('data-from'), 10);
    const min = Math.min(to, from);
    const max = Math.max(to, from);
    const dcid = `${min}-${max}`;
    // Fix dcid if wrong (in invite case)
    const splArr = reciver.attr('id').split('-');
    if (splArr.length < 2) {
      reciver.attr('id', dcid);
    }
    if (message.val().length > 0) {
      let messageVal = message.val();
      // $.post('ajaxAdd.php', $('directchat-form').serialize());
      $.ajax({
        url: '/directchat/ajax_chat.php',
        method: 'POST',
        data: {
          mode: 'addMessage',
          text: messageVal,
          cid: dcid,
          reciver: parseInt(reciver.attr('data-reciver'), 10)
        },
        success: () => {
          // this.loadConversation2(reciver.attr('id'));
        }
      });
      message.val('');
      messageVal = '';
    }
    message.focus();
  }

  // Load conversation-wrapper into the chatbox.
  openConversation(id, to, name, invitation) {
    if (invitation) {
      cookie.Set('dcbxmin', 0, 3600, '/');
    }
    this.lastid = 0;
    $.ajax({
      url: '/directchat/ajax_chat.php',
      method: 'POST',
      type: 'html',
      data: {
        mode: 'open',
        cid: id,
        uid: to,
        uname: name,
        invited: invitation * 1
      },
      success: data => {
        if (data) {
          const response = $.parseJSON(data);
          $('#directchat-content').html(response.render);
          if (parseInt(cookie.Get('dcbxmin'), 10) === 0) {
            $('#chatbox-toggle-button').click();
          }
          $(this.el).show();
        }
      }
    });
    this.startNewLinesWatchDog(id, 1000);
  }

  loadConversation2(dcid) {
    const conversation = $('body').find('#conversation');
    const dchat = conversation.parents('.dchat');
    const to = parseInt(dchat.attr('data-reciver'), 10);
    const from = parseInt(dchat.attr('data-from'), 10);
    const min = Math.min(to, from);
    const max = Math.max(to, from);
    const cid = `${min}-${max}`;
    const splt = dcid.split('-');
    const myDCid = splt.length < 2 ? cid : dcid;
    if (conversation.length > 0) {
      $.post(
        '/directchat/ajax_chat.php',
        {
          mode: 'refresh',
          id: myDCid,
          last: this.lastid
        },
        data => {
          const response = $.parseJSON(data);
          if (response.render) {
            conversation.find('dl').append(response.render);
            const sender = parseInt(response.sender, 10);
            // const reciver = parseInt(response.reciver, 10);
            const validId = parseInt(response.valid_id, 10);
            // console.log('sender => ', response.sender);
            // console.log('reciver => ', response.reciver);
            // console.log('valid_id => ', response.valid_id);
            // const soundOn = this.el.getAttribute('data-dc-snd');
            // console.log('cd private_sound', cookie.Get('private_sound'));
            if (
              validId !== sender &&
              parseInt(cookie.Get('private_sound'), 10) === 1
            ) {
              // console.log('RECIVER');
              dc.try2play();
            }
            conversation.animate(
              { scrollTop: conversation[0].scrollHeight },
              'slow'
            );
            if (response.last) {
              this.lastid = response.last;
            }
          }
        }
      );
    } else {
      this.stopNewLinesWatchDog();
    }
  }

  // Load conversation-wrapper into the conversation-wrapper.
  loadConversation(id, open) {
    const submode = open ? 1 : 0;
    const currentid = id ? cookie.Get('dccrr') : id;
    const dclast = $('body')
      .find('#directchat-wrapper')
      .attr('data-eval-id');
    $.ajax({
      url: '/directchat/ajax_chat.php',
      method: 'POST',
      type: 'html',
      data: {
        mode: 'getNewLines',
        cid: currentid,
        last: open === 1 ? 0 : dclast,
        opn: submode
      },
      success: data => {
        const response = $.parseJSON(data);
        const newText = response.new_text;
        if (newText !== undefined && newText.length) {
          let conversation = $('body').find('#conversation');
          if (conversation !== null) {
            if (conversation.length === 0) {
              conversation = document.getElementById('conversation');
            } else {
              $('body')
                .find('#directchat-wrapper')
                .attr('data-eval-id', response.last);
              $('body')
                .find('#dc-check-test')
                .html(response.last);
              conversation.find('dl').append(newText);
              conversation.animate(
                { scrollTop: conversation[0].scrollHeight },
                'slow'
              );
            }
          }
        }
      }
    });
  }

  // Stop the watchdog by inactivity
  stopByInactivity() {
    this.stopNewLinesWatchDog();
  }

  // Start interval action - Load new message(s).
  startNewLinesWatchDog(id, duration) {
    let i = 0;
    let cid = id;
    this.newLines = setInterval(() => {
      if (!cid) {
        cid = cookie.Get('dccrr');
      }
      // Watch for chat updates or invitations.
      this.loadConversation2(cid);
      i += i;
    }, duration);
  }

  // Stops the interval action - Load new message(s).
  stopNewLinesWatchDog() {
    clearInterval(this.newLines);
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/directchat.js